import SmoothScroll from "../components/SmoothScroll";
import { LanguageProvider } from "../i18n/LanguageContext";
import { Navbar } from "../components/site/Navbar";
import { FixedVideo } from "../components/site/FixedVideo";
import { SectionProgress } from "../components/site/SectionProgress";
import { JourneyContent } from "../components/site/JourneyContent";
import { Contact, Footer } from "../components/site/Contact";

export default function Landing() {
  return (
    <LanguageProvider>
      <SmoothScroll>
        <div className="relative overflow-x-clip">
          <FixedVideo />
          <Navbar />
          <SectionProgress />
          <main className="relative z-10">
            <JourneyContent />
            <Contact />
          </main>
          <div className="relative z-10"><Footer /></div>
        </div>
      </SmoothScroll>
    </LanguageProvider>
  );
}
